module.exports = __webpack_public_path__ + "img/iphone.2859f244.png";